import React from 'react';
import RankPuzzle from './puzzles/RankPuzzle';
import MultiplePuzzle from './puzzles/MultiplePuzzle';
import UnscramblePuzzle from './puzzles/UnscramblePuzzle';
import MazePuzzle from './puzzles/MazePuzzle';
import SpotPuzzle from './puzzles/SpotPuzzle';
import FillInPuzzle from './puzzles/FillInPuzzle';
import StoryPuzzle from './puzzles/StoryPuzzle';
import TriviaPuzzle from './puzzles/TriviaPuzzle';
import MatchingPuzzle from './puzzles/MatchingPuzzle';

const PUZZLE_COMPONENTS = {
  rank: RankPuzzle,
  multiple: MultiplePuzzle,
  unscramble: UnscramblePuzzle,
  maze: MazePuzzle,
  spot: SpotPuzzle,
  fillin: FillInPuzzle,
  story: StoryPuzzle,
  trivia: TriviaPuzzle,
  matching: MatchingPuzzle,
};

export default function PuzzleModal({ stop, onSolved, onClose }) {
  const PuzzleComponent = PUZZLE_COMPONENTS[stop.puzzleType];

  if (!PuzzleComponent) {
    return (
      <div className="puzzle-overlay" onClick={onClose}>
        <div className="puzzle-modal" onClick={(e) => e.stopPropagation()}>
          <p>Unknown puzzle type: {stop.puzzleType}</p>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="puzzle-overlay" onClick={onClose}>
      <div className="puzzle-modal" onClick={(e) => e.stopPropagation()}>
        <button className="puzzle-close" onClick={onClose}>✕</button>
        <h2 className="puzzle-title">{stop.name}</h2>
        <PuzzleComponent data={stop.puzzleData} onSolved={onSolved} />
      </div>
    </div>
  );
}
